var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrosoftTeams(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20.1376 9.05555c1.1559 0 2.093-.93707 2.093-2.09302 0-1.15594-.9371-2.09302-2.093-2.09302-1.156 0-2.093.93708-2.093 2.09302 0 1.15595.937 2.09302 2.093 2.09302z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.0215 18.7972c.1346.017.2717.0257.411.0257h.0153c1.7938 0 3.2479-1.4541 3.2479-3.2479v-4.7056c0-.488-.3956-.88368-.8837-.88368h-2.5181c.1425.26968.221.57788.2157.90388v5.3464c.0195.908-.156 1.7751-.4881 2.5612z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.2096 17.9435c-.6311-.5924-1.0254-1.4341-1.0255-2.368v-4.5898h1.3255v5.2731l.0003.0116c.0138.591-.0939 1.1567-.3003 1.6731z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.9281 9.03159c1.5278-.15167 2.721-1.44066 2.721-3.00833 0-1.6697-1.3536-3.02326-3.0233-3.02326s-3.0233 1.35356-3.0233 3.02326c0 .05766.0017.11494.0048.17181h1.4682c1.0232 0 1.8526.82943 1.8526 1.85255z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.9281 8.5252v-.33013h-.4055c.1252.12127.2609.23181.4055.33013z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.27593 16.4276c-.00063-.0599-.00025-.1201.00115-.1805v-1.0712h.47292v-4.5h1.75v-.69018h1.4281v6.44188z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.695 18.4276h3.3805c1.0232 0 1.8526-.8294 1.8526-1.8525v-6.58938h3.729c.4822.01193.8637.41218.8525.89438v5.367c.0674 2.8941-2.2223 5.2957-5.1162 5.3665-2.1203-.0519-3.91617-1.3548-4.6984-3.186z"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m12.0757 7.19507h-8.52747c-.47084 0-.85255.3817-.85255.85255v8.52748c0 .4708.3817.8525.85255.8525h8.52747c.4708 0 .8525-.3817.8525-.8525v-8.52748c0-.47085-.3817-.85255-.8525-.85255zm-6.5757 3.48083h1.75v4.5h1v-4.5h1.75v-1h-4.5z",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftTeams);
export default __webpack_public_path__ + "static/media/microsoft-teams.edd3df9f145ecfbada47fe88f964578b.svg";
export { ForwardRef as ReactComponent };